import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ChatsService as ApiChatsService, ChatView, Id } from '@src/api';

@Injectable({
  providedIn: 'root',
})
export class ChatsService {
  private readonly chatsService = inject(ApiChatsService);

  chats$ = new BehaviorSubject<ChatView[] | null>(null);
  chatsIds$ = new BehaviorSubject<number[]>([]);

  constructor() {
    this.chats$.subscribe(chats => {
      const chatsIds = chats?.map(chat => chat.chatId!);
      this.chatsIds$.next(chatsIds ?? []);
    });
  }

  addChat(chatId: number, chatType: number, description: string): Observable<Id> {
    return this.chatsService.addChat({ chatId, chatType, description }).pipe(
      catchError(err => {
        // TODO show error notification
        return throwError(() => err);
      }),
    );
  }

  getChats(chatsIds: number[]): void {
    this.chatsService
      .getChats(chatsIds)
      .pipe(
        catchError(err => {
          // TODO show error notification
          return throwError(() => err);
        }),
      )
      .subscribe(chats => this.chats$.next(chats));
  }

  getChatsData(chatsIds: number[]): Observable<ChatView[]> {
    return this.chatsService.getChats(chatsIds).pipe(
      catchError(err => {
        // TODO show error notification
        return throwError(() => err);
      }),
    );
  }

  getChatsIdsData(chatsIds: number[]): Observable<number[]> {
    return this.chatsService.getChats(chatsIds).pipe(
      catchError(err => {
        // TODO show error notification
        return throwError(() => err);
      }),
      map(chats => chats.map(chat => chat.chatId).filter(id => id !== undefined) as number[]),
    );
  }

  getInternalChatIds(chatId: number[]): Observable<string[]> {
    return this.chatsService.getChats(chatId).pipe(
      catchError(err => {
        // TODO show error notification
        return throwError(() => err);
      }),
      map(chats => chats.map(chat => chat.id).filter(id => id !== undefined) as string[]),
    );
  }

  deleteChat(internalChatId: string): Observable<Id> {
    return this.chatsService.deleteChat(internalChatId).pipe(
      catchError(err => {
        // TODO show error notification
        return throwError(() => err);
      }),
    );
  }

  resetChats(): void {
    this.chats$.next(null);
  }

  resetAll(): void {
    this.resetChats();
  }
}
